module.exports = __webpack_public_path__ + "static/media/closed-stamp.3a8b5df6.jpg";